import "./App.css";
import Palette from "./Palette";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import { isMobile } from "react-device-detect";

const PaletteCreateHome = () => {
  return (
    <div className="App">
      <div className="headingBox">
        <div className="logoHeading">
          <img src="./images/logo.png" alt="logo" className="logo" />
          <div className="headingTextContainer">
            <h1 className="heading1">The Little Hook Crochet</h1>
            <h1 className="heading2">Yarn Palette Creator</h1>
          </div>
        </div>
      </div>

      {isMobile ? (
        <div className="instructionsContainer">
          <div className="instructions">
            <p className="instructionText">
              • Tap on swatches to add to your palette
            </p>
            <p className="instructionText">
              • Drag & drop swatches within the palette to change order
            </p>
            <p className="instructionText">
              • Tap cross within swatch to remove from palette
            </p>
          </div>
        </div>
      ) : (
        <div className="instructionsContainer">
          <div className="instructions">
            <p className="instructionText">
              • Click on swatches to add to your palette
            </p>
            <p className="instructionText">
              • Drag & drop swatches within the palette to change order
            </p>
            <p className="instructionText">
              • Click cross within swatch to remove from palette
            </p>
            <p className="instructionText">
              • Download an image of your palette with "Take Photo" button
            </p>
          </div>
        </div>
      )}

      {isMobile ? (
        <DndProvider backend={TouchBackend}>
          <Palette isMobile={isMobile} />
        </DndProvider>
      ) : (
        <DndProvider backend={HTML5Backend}>
          <Palette isMobile={isMobile} />
        </DndProvider>
      )}
    </div>
  );
};

export default PaletteCreateHome;
